import React from 'react';
import './animations.css';
import ocohstech_background from "../Assets/ocohstech_background.webp";

const courses = [
    {
        tag: "Medical",
        title: "Community Health",
        body: "Community Health focuses on promoting and protecting the health of populations through education, prevention, and health services. It equips students with skills to address public health issues, implement programs, and improve overall community well-being.",
    },
    {
        tag: "Medical",
        title: "Medical Laboratory Science",
        body: "Medical Laboratory Science trains students to analyze human samples for diagnosing and treating diseases. It combines theory with hands-on practice in areas like microbiology, hematology, and clinical chemistry, preparing graduates for vital roles in healthcare and research.",
    },
    {
        tag: "Medical",
        title: "Pharmacy",
        body: "Pharmacy focuses on the study of drugs and their effects, preparing students to dispense medications and counsel patients. It combines science and healthcare to ensure safe and effective use of medicines, contributing to improved patient outcomes.",
    },
    {
        tag: "Medical",
        title: "Dispensary & Optometry Technician",
        body: "This course trains students to assist in dispensing medications and providing basic eye care services. It combines skills in pharmacy support and optometry to prepare graduates for roles in healthcare settings.",
    },
];

const Secthree = () => {
    return (
        <div className="w-full bg-[#F6F5F1] pt-20 pb-24 px-4 md:px-10 lg:px-16">

            <div className="flex flex-col items-center text-center mb-16">
                <div className="flex items-center gap-2 mb-5">
                    <span className="w-6 h-[1.5px] bg-[#B8862E]" />
                    <span className="text-[#B8862E] text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                        Courses
                    </span>
                    <span className="w-6 h-[1.5px] bg-[#B8862E]" />
                </div>
                <h2
                    className="text-3xl md:text-4xl text-[#12213D] leading-tight mb-4"
                    style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}
                >
                    Our courses
                </h2>
                <p
                    className="text-[#5B6472] text-base md:text-lg leading-relaxed max-w-xl"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                >
                    Our featured courses provide a comprehensive curriculum designed to equip students with the skills and knowledge necessary for success in their chosen fields.
                </p>
            </div>

            <div className="flex flex-col gap-4">
                {courses.map((course) => (
                    <div
                        key={course.title}
                        className="bg-white border border-[#12213D]/10 flex flex-col md:flex-row gap-6 px-6 py-6 md:px-8 md:py-8"
                    >
                        <img
                            src={ocohstech_background}
                            className="w-full md:w-56 h-48 md:h-auto object-cover rounded-sm shrink-0"
                            alt={course.title}
                        />
                        <div className="flex flex-col justify-center">
                            <span className="w-fit bg-[#925FE2] text-white text-sm px-3 py-1 rounded-sm mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
                                {course.tag}
                            </span>
                            <h3
                                className="text-xl text-[#12213D] mb-2"
                                style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}
                            >
                                {course.title}
                            </h3>
                            <p
                                className="text-[#5B6472] leading-relaxed max-w-2xl"
                                style={{ fontFamily: "'Inter', sans-serif" }}
                            >
                                {course.body}
                            </p>
                            <p className="mt-4 text-[#925FE2] text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                                <span className="font-medium text-[#12213D]">HOD: </span>
                            </p>
                        </div>
                    </div>
                ))}
            </div>

            <div className="flex justify-center">
                <button className="flex items-center gap-1.5 bg-[#925FE2] hover:bg-[#7f4fd1] text-white px-6 py-3 rounded-sm text-sm font-medium mt-14 transition-colors" style={{ fontFamily: "'Inter', sans-serif" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m12.75 15 3-3m0 0-3-3m3 3h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                    <span>View all courses</span>
                </button>
            </div>
        </div>
    )
}

export default Secthree;